module.exports = __webpack_public_path__ + "media/images/athletes/2473-75d2674ea93c52b2de608e889a2bb1ca.png";